import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useTexts } from '../../../useTexts'

interface ButtonCancelProps {
  isContained?: boolean
}

export function ButtonCancel({ isContained = false }: ButtonCancelProps) {
  const ctrl = useController()
  const texts = useTexts()

  return (
    <ModalFooterButton
      testid="modal-secondary-button"
      title={texts.buttonCancel}
      onClick={ctrl.close}
      {...(isContained && { variant: 'contained' })}
    >
      {texts.buttonCancel}
    </ModalFooterButton>
  )
}
